'use strict';

var currency = require('../types/currency.cjs');
var trans = require('./trans.cjs');

const getCurrencySymbol = (currencyCode) => {
  const MAP = {
    [currency.CurrencyCode.Krw]: currency.CurrencySymbol.Krw,
    [currency.CurrencyCode.Usd]: currency.CurrencySymbol.Usd,
    [currency.CurrencyCode.Jpy]: currency.CurrencySymbol.Jpy
  };
  return MAP[currencyCode];
};
const getCurrencyLabelI18nKey = (currencyCode) => {
  const MAP = {
    [currency.CurrencyCode.Krw]: trans.trans("global.currency.\uC6D0"),
    [currency.CurrencyCode.Usd]: trans.trans("global.currency.\uB2EC\uB7EC"),
    [currency.CurrencyCode.Jpy]: trans.trans("global.currency.\uC5D4")
  };
  return MAP[currencyCode];
};

exports.getCurrencyLabelI18nKey = getCurrencyLabelI18nKey;
exports.getCurrencySymbol = getCurrencySymbol;
//# sourceMappingURL=currency.cjs.map
